// extracted by mini-css-extract-plugin
export var avatarContainer = "_ef-0";
export var avatarTypingWave = "_ef-i";
export var gray = "_ef-f";
export var green = "_ef-c";
export var icon = "_ef-9";
export var image = "_ef-1";
export var lg = "_ef-6";
export var md = "_ef-5";
export var presenceDot = "_ef-b";
export var red = "_ef-d";
export var sm = "_ef-4";
export var status = "_ef-a";
export var typingDot = "_ef-h";
export var typingPill = "_ef-g";
export var xl = "_ef-7";
export var xs = "_ef-3";
export var xxl = "_ef-8";
export var xxs = "_ef-2";
export var yellow = "_ef-e";